import PracticePageV2 from "@/components/site/v2/PracticePageV2";
import { DIGITAL_PAGE as page } from "@/data/digitalPage";

const CAP_URL = "/capabilities/digital-commerce";

export default function DigitalPage() {
  const explorerItems = page.offers.map((o) => ({
    name: o.name,
    outcome: o.lead,
    body: o.body,
    covers: o.list,
    link: o.slug ? { to: `${CAP_URL}/${o.slug}`, label: `Explore ${o.name}` } : undefined,
  }));

  return (
    <PracticePageV2
      testid="digital-page"
      page={page}
      capUrl={CAP_URL}
      image="/photos/practice-hero-digital.jpg"
      imageAlt="Indian team working at laptops around a long table in a bright office"
      heroDescription="Connect acquisition, conversion, commerce and retention to improve digital revenue and customer economics."
      heroTagline="Turn digital investment into profitable growth."
      challenges={page.challengeProblems.map((q) => ({ title: q, to: "#capabilities" }))}
      explorerItems={explorerItems}
      deliverables={page.deliverGroups.flatMap((g) => g.items)}
      outcomes={page.outcomes}
      frameworkSteps={page.connectStages.map((s) => ({ name: s.name, desc: s.channels }))}
      frameworkHeadline={page.connectLead}
      frameworkKicker={page.connectClosing?.[0]}
    />
  );
}
